import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { FileText, Download, Mail } from "lucide-react";

export const MyReports = () => {
    const [items, setItems] = useState(null);

    useEffect(() => {
        api.get("/me/reports").then((r) => setItems(r.data.items || [])).catch((e) => console.error(e));
    }, []);

    if (!items) return null;

    return (
        <div data-testid="my-reports-section" className="mt-16">
            <span className="label-eyebrow">Report mensili</span>
            <h2 className="font-serif text-3xl text-ink-50 mt-2 mb-2">I miei report</h2>
            <p className="text-xs text-ink-400 mb-6 max-w-2xl">
                Il primo giorno di ogni mese generiamo automaticamente il report della tua attività (lead, match, clienti contattati, immobili acquisiti) e te lo inviamo via email. Qui trovi lo storico degli ultimi 12 mesi.
            </p>
            {items.length === 0 ? (
                <div data-testid="my-reports-empty" className="border border-white/10 p-10 text-center text-sm text-ink-400">
                    Nessun report ancora disponibile. Il primo sarà generato il 1° del prossimo mese e lo riceverai anche via email.
                </div>
            ) : (
                <div className="border border-white/10 divide-y divide-white/5">
                    {items.map((r) => (
                        <div key={r.id} data-testid={`report-row-${r.period}`} className="p-4 grid grid-cols-12 gap-3 items-center text-sm">
                            <div className="col-span-4 flex items-center gap-3">
                                <FileText size={16} className="text-gold shrink-0" />
                                <span className="font-serif text-ink-50">{r.period_label}</span>
                            </div>
                            <div className="col-span-3 text-xs text-ink-400">
                                Generato il {new Date(r.generated_at).toLocaleDateString("it-IT")}
                            </div>
                            <div className="col-span-3 text-xs">
                                {r.email_status === "delivered" ? (
                                    <span className="px-2 py-1 bg-green-900/30 text-green-400 inline-flex items-center gap-1.5"><Mail size={11} /> Inviato via email</span>
                                ) : r.email_status === "failed" ? (
                                    <span className="px-2 py-1 bg-red-900/30 text-red-400">Invio email fallito</span>
                                ) : (
                                    <span className="px-2 py-1 bg-ink-900 text-ink-400">Non inviato</span>
                                )}
                            </div>
                            <div className="col-span-2 flex justify-end">
                                <button
                                    data-testid={`report-download-${r.period}`}
                                    onClick={() => window.open(`${process.env.REACT_APP_BACKEND_URL}/api/me/reports/${r.id}/pdf`, "_blank")}
                                    className="cta-outline px-4 py-2 text-xs flex items-center gap-2"
                                >
                                    <Download size={12} /> Scarica PDF
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};
